"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshItemsPosition = exports.getUpdatedItemsWithIncrement = exports.getUpdatedItemsWithDecrement = exports.getSelectAllItems = exports.getItemsWithNewUrl = exports.getItemsInitialState = exports.getItemChanged = exports.getDeselectAllItems = exports.fillCheckedItems = void 0;
var _manageItem = require("./manageItem");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getItemsInitialState = exports.getItemsInitialState = function getItemsInitialState(listOfSrc) {
  var initializedItem = listOfSrc.map(function (src, index) {
    return {
      id: index + 1,
      src: src,
      checked: false,
      position: 0,
      height: 0,
      width: 0,
      size: 0,
      sizeError: false,
      aspectRatio: 0,
      aspectRatioError: false,
      fetchError: false,
      loading: true
    };
  });
  return initializedItem;
};
var getItemsWithNewUrl = exports.getItemsWithNewUrl = function getItemsWithNewUrl(listOfItems, newUrlItem) {
  var oldUrl = newUrlItem.oldUrl,
    newUrl = newUrlItem.newUrl;
  var updatedItems = listOfItems.map(function (item) {
    if (item.src === oldUrl) {
      return _objectSpread(_objectSpread({}, item), {}, {
        src: newUrl,
        hasNewUrl: true
      });
    }
    return _objectSpread(_objectSpread({}, item), {}, {
      hasNewUrl: false
    });
  });
  return updatedItems;
};
var getUpdatedItemsWithIncrement = exports.getUpdatedItemsWithIncrement = function getUpdatedItemsWithIncrement(listOfItems, targetItem) {
  var maxPosition = Math.max.apply(Math, _toConsumableArray(listOfItems.map(function (item) {
    return item.position;
  })));
  var newItems = listOfItems.map(function (item) {
    return item.id === targetItem.id ? _objectSpread(_objectSpread({}, targetItem), {}, {
      checked: true,
      position: maxPosition + 1
    }) : item;
  });
  return newItems;
};
var getUpdatedItemsWithDecrement = exports.getUpdatedItemsWithDecrement = function getUpdatedItemsWithDecrement(listOfItems, targetItem) {
  var targetItemPosition = targetItem.position;
  var newItems = listOfItems.map(function (item) {
    return item.id === targetItem.id ? _objectSpread(_objectSpread({}, item), {}, {
      checked: false,
      position: 0
    }) : item.position > targetItemPosition ? _objectSpread(_objectSpread({}, item), {}, {
      position: item.position - 1
    }) : item;
  });
  return newItems;
};
var fillCheckedItems = exports.fillCheckedItems = function fillCheckedItems(listOfItems, maxSelectable) {
  var items = _toConsumableArray(listOfItems);
  var changed = false;

  // Obtención de cambios de url y handleo en item afectado
  items = items.map(function (item) {
    if (item.hasNewUrl) {
      changed = true;

      // Deseleción de items con nueva url
      if (item.checked) {
        return _objectSpread(_objectSpread({}, item), {}, {
          checked: false,
          position: 0,
          hasNewUrl: false
        });
      }
      return _objectSpread(_objectSpread({}, item), {}, {
        hasNewUrl: false
      });
    }
    return item;
  });

  // Auto check en items cuando no hubo cambio de url
  if (!changed) {
    var updatedItems = [];
    var nextPosition = 1;
    var checkedCount = 0;
    for (var index = 0; index < listOfItems.length; index++) {
      var item = items[index];
      var isSomeError = item.fetchError || item.sizeError || item.aspectRatioError;
      var checked = checkedCount < maxSelectable && !isSomeError;
      var position = 0;
      if (checked) {
        position = nextPosition;
        nextPosition++;
        checkedCount++;
      }
      updatedItems.push(_objectSpread(_objectSpread({}, item), {}, {
        checked: checked,
        position: position
      }));
    }
    return updatedItems;
  }

  // Reorden de items en estado check cuando hubo cambios de url
  var currentPosition = 1;
  var reorderedItems = items.map(function (item) {
    if (item.checked) {
      return _objectSpread(_objectSpread({}, item), {}, {
        position: currentPosition++
      });
    } else {
      return _objectSpread(_objectSpread({}, item), {}, {
        position: 0
      });
    }
  });
  return reorderedItems;
};
var refreshItemsPosition = exports.refreshItemsPosition = function refreshItemsPosition(items) {
  var currentPosition = 1;
  return items.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      position: item.checked ? currentPosition++ : 0
    });
  });
};
var getSelectAllItems = exports.getSelectAllItems = function getSelectAllItems(listOfItems, maxSelectable) {
  var numberOfItemsAlreadyChecked = listOfItems.filter(function (item) {
    return item.checked;
  }).length;
  var newMaxPosition = Math.max.apply(Math, _toConsumableArray(listOfItems.map(function (item) {
    return item.position;
  }))) + 1;
  var isMaxSelectableReached = numberOfItemsAlreadyChecked >= maxSelectable;
  var newItems = listOfItems.map(function (item) {
    if (item.checked) return item;
    if (isMaxSelectableReached) return item;
    if (!(0, _manageItem.isItemClickable)(item, isMaxSelectableReached, true)) return item;
    var newItem = _objectSpread(_objectSpread({}, item), {}, {
      checked: true,
      position: newMaxPosition
    });
    newMaxPosition++;
    numberOfItemsAlreadyChecked++;
    isMaxSelectableReached = numberOfItemsAlreadyChecked >= maxSelectable;
    return newItem;
  });
  return newItems;
};
var getDeselectAllItems = exports.getDeselectAllItems = function getDeselectAllItems(listOfItems) {
  return listOfItems.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      checked: false,
      position: 0
    });
  });
};
var getItemChanged = exports.getItemChanged = function getItemChanged(originalList, newList) {
  var length = Math.min(originalList.length, newList.length);
  for (var i = 0; i < length; i++) {
    if (originalList[i] !== newList[i]) {
      return {
        oldUrl: originalList[i],
        newUrl: newList[i]
      };
    }
  }
  return null;
};